import React from 'react'

const DefaultIcon = () => (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1.35C0 0.991958 0.142232 0.64858 0.395406 0.395406C0.64858 0.142232 0.991958 0 1.35 0H9.84555C10.2036 7.64605e-05 10.5469 0.142359 10.8 0.39555L15.8045 5.4C16.0576 5.65312 16.1999 5.99644 16.2 6.35445V20.25C16.2 20.608 16.0578 20.9514 15.8046 21.2046C15.5514 21.4578 15.208 21.6 14.85 21.6H1.35C0.991958 21.6 0.64858 21.4578 0.395406 21.2046C0.142232 20.9514 0 20.608 0 20.25V1.35ZM9.45 1.35H1.35V20.25H14.85V6.75H10.8C10.442 6.75 10.0986 6.60777 9.8454 6.35459C9.59223 6.10142 9.45 5.75804 9.45 5.4V1.35ZM10.8 2.30445V5.4H13.8955L10.8 2.30445ZM12.15 12.15H4.05V10.8H12.15V12.15ZM12.15 16.2H4.05V14.85H12.15V16.2Z"
      fill="#42B0D5"
    />
  </svg>
)

export default DefaultIcon
